import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useCampaign } from '../../contexts/CampaignContext/useCampaign';
import { createKeyboardActivationHandler } from '../../utils/keyboardActivation';
import './style.less';

export const CampaignConditions = () => {
  const { t, i18n } = useTranslation();
  const { campaign, isCampaignActive } = useCampaign();
  const [isOpen, setIsOpen] = useState(false);

  if (!isCampaignActive || !campaign?.conditions) {
    return null;
  }

  const conditions = campaign.conditions[i18n.language] || campaign.conditions.bg;

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyDown = createKeyboardActivationHandler(toggleAccordion);

  return (
    <div className="campaign-conditions">
      <button
        className="conditions-toggle"
        onClick={toggleAccordion}
        onKeyDown={handleKeyDown}
        aria-expanded={isOpen}
        aria-controls="campaign-conditions-content"
      >
        <span className="toggle-text">{t('campaign.conditions')}</span>
        <motion.i
          className="fas fa-chevron-down"
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            id="campaign-conditions-content"
            className="conditions-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                >
                  <i className="fas fa-check"></i>
                  <span>{condition}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
